import { DataRangeValue } from "@/_old/components/ds-components/inputs/date-range";
import i18n from "i18next";

const getLanguage = () => i18n.language.replace("_", "-");

export const calculateDateDiffInDays = (firstDate: Date, secondDate: Date) => {
  const diffTime = secondDate.getTime() - firstDate.getTime();
  return Math.round(diffTime / (1000 * 60 * 60 * 24));
};

export const calculateDateDiffInMonths = (
  firstDate: Date,
  secondDate: Date,
) => {
  const diffDate = (secondDate.getDate() - firstDate.getDate()) / 30;
  const diffYear = (secondDate.getFullYear() - firstDate.getFullYear()) * 12;
  const diffMonth =
    diffDate + diffYear + secondDate.getMonth() - firstDate.getMonth();

  return Math.ceil(diffMonth);
};

export const parseDateToISOWithoutTimezone = (date: Date) => {
  return date.toISOString().split("T")[0];
};

export const parseDateToISOWithTimezone = (date: Date) => {
  const tzOffset = -date.getTimezoneOffset();
  const diff = tzOffset >= 0 ? "+" : "-";
  const pad = (n: number) => `${Math.floor(Math.abs(n))}`.padStart(2, "0");
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(
    date.getDate(),
  )}T${pad(date.getHours())}:${pad(date.getHours())}:${pad(
    date.getMinutes(),
  )}:${pad(date.getSeconds())}${diff}${pad(tzOffset / 60)}:${pad(
    tzOffset % 60,
  )}`.split("T")[0];
};

export const getRangeBetweenDates = ({
  initialDate,
  finalDate,
}: DataRangeValue) => {
  const minValue = new Date(
    new Date(String(initialDate)).setDate(initialDate?.getDate()!! + 1),
  );
  const maxValue = new Date(
    new Date(String(finalDate)).setDate(finalDate?.getDate()!! + 1),
  );

  return {
    minValue,
    maxValue,
  };
};

export const formatDate = (date: Date, forceUTCZero: boolean = false) => {
  const formatter = new Intl.DateTimeFormat(getLanguage(), {
    timeZone: forceUTCZero ? "Australia/Sydney" : undefined,
    dateStyle: "short",
  });
  return formatter.format(date);
};

export const getMonthName = (date: Date, forceUTCZero: boolean = false) => {
  const formatter = new Intl.DateTimeFormat(getLanguage(), {
    timeZone: forceUTCZero ? "Australia/Sydney" : undefined,
    month: "long",
  });
  const monthName = formatter.format(date);
  const monthNameCapitalized =
    monthName.charAt(0).toUpperCase() + monthName.slice(1);
  return monthNameCapitalized;
};

export const getDayName = (date: Date) => {
  const formatter = new Date(date).toLocaleDateString(getLanguage(), {
    weekday: "long",
  });

  const dayNameCapitalized =
    formatter.charAt(0).toUpperCase() + formatter.slice(1);

  return dayNameCapitalized;
};

export const getLastDayOfMonth = (date: Date = new Date()) => {
  return new Date(date.getFullYear(), date.getMonth() + 1, 0);
};
